const displayRoutes = {
  index: {
    path: 'index.setting.display',
    url: '/display',
  },
}

export default displayRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/display/routes.js